import React, { useState, useEffect } from "react";
import { FiMinus } from "react-icons/fi";
import { IoMdAdd } from "react-icons/io";
import { MdClose } from "react-icons/md";
import InputCheckbox from "../inputs/inputCheckbox/inputCheckbox";

import "./cartItem.scss";

const CartItem = ({
    itemName,
    itemRef,
    imageSrc,
    onRemove,
    showCheckbox = false,
    showImage = false,
    showRemoveIcon = false,
    totalItems = 1,
    checked = false,
    onChange,
    initialQuantity = 1,
    onQuantityChange,
}) => {
    const [quantity, setQuantity] = useState(initialQuantity);
    const [localChecked, setLocalChecked] = useState(checked);

    useEffect(() => {
        setQuantity(initialQuantity);
        setLocalChecked(checked);
    }, [initialQuantity, checked]);

    const incrementQuantity = () => {
        const newQuantity = quantity + 1;
        setQuantity(newQuantity);

        if (onQuantityChange) {
            onQuantityChange(newQuantity);
        }

        if (newQuantity > 0 && !localChecked && onChange) {
            setLocalChecked(true);
            onChange(true);
        }
    };

    const decrementQuantity = () => {
        const newQuantity = Math.max(0, quantity - 1);
        setQuantity(newQuantity);

        if (onQuantityChange) {
            onQuantityChange(newQuantity);
        }

        if (newQuantity === 0 && localChecked && onChange) {
            setLocalChecked(false);
            onChange(false);
        }
    };

    const handleCheckboxChange = (isChecked) => {
        setLocalChecked(isChecked);
        if (onChange) {
            onChange(isChecked);
        }

        if (isChecked && quantity === 0 && onQuantityChange) {
            const newQuantity = 1;
            setQuantity(newQuantity);
            onQuantityChange(newQuantity);
        }
    };

    return (
        <div
            className={`cart-item ${
                totalItems === 1 ? "cart-item--single" : ""
            }`}
        >
            {showCheckbox && (
                <InputCheckbox
                    checked={localChecked}
                    onChange={handleCheckboxChange}
                />
            )}

            {showImage && imageSrc && (
                <img
                    src={imageSrc}
                    alt={itemName}
                    className="cart-item__image"
                />
            )}

            <div className="cart-item__info">
                <h3 className="cart-item__label" title={itemName}>
                    {itemName}
                </h3>
                {itemRef && (
                    <span className="cart-item__ref" title={itemRef}>
                        {itemRef}
                    </span>
                )}
            </div>

            <div className="cart-item__toggle">
                <button
                    onClick={decrementQuantity}
                    className="cart-item__button"
                    type="button"
                    disabled={quantity <= 0}
                >
                    <FiMinus />
                </button>
                <span className="cart-item__quantity">{quantity}</span>
                <button
                    onClick={incrementQuantity}
                    className="cart-item__button"
                    type="button"
                >
                    <IoMdAdd />
                </button>
            </div>

            {showRemoveIcon && (
                <button
                    onClick={onRemove}
                    className="cart-item__remove"
                    type="button"
                >
                    <MdClose />
                </button>
            )}
        </div>
    );
};

export default CartItem;
